import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

type StyleEntry =
  | SystemStyleObject<Theme>
  | ((theme: Theme) => SystemStyleObject<Theme>);

export const styles = {
  paginationContainer: (theme) => ({
    position: 'fixed',
    display: 'flex',
    zIndex: 2,
    backgroundColor: theme.palette.mode === 'light' ? 'white' : undefined,
    bottom: '0px',
    right: '10px',
  }),
  pagination: (theme) => ({
    '& .MuiPagination-ul': {
      flexWrap: 'nowrap',
    },
    '& .MuiPaginationItem-root': {
      color: theme.palette.text.secondary,
    },
  }),
  tablePagination: (theme) => ({
    '& .MuiTablePagination-selectRoot': {
      borderRadius: '6px',
      overflow: 'hidden',
    },
    '& .MuiTablePagination-input': {
      color: theme.palette.text.secondary,
    },
    '& .MuiTablePagination-caption': {
      color: theme.palette.text.secondary,
    },
    '& .MuiTablePagination-selectIcon': {
      color: theme.palette.cherry[300],
    },
  }),
} satisfies Record<string, StyleEntry>;
